import { getAPI } from '../config';
const AUDIENCE_Access = 'https://aurecongroup.com/fc0f51ae-6f00-446a-be4c-529ee925161a/user_impersonation';
let apitoken = null;
export const setApiToken = (v) => {
    // console.log(`Setting api token :DataSharing ${v!=null}`)
    apitoken = v;
};
const getToken = async (audience) => {
    let token = null;
    try {
        if (apitoken) {
            // console.log(`Get Token Data Sharing: api token exists ${audience}`)
            token = await apitoken(audience);
            // console.log(`Token: ${token}`)
        }
        return token;
    }
    catch (ex) {
        console.log(ex);
        throw ex;
    }
};
const getAuthHeader = async (audience) => {
    const token = await getToken(audience);
    const answer = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    };
    return answer;
};
const handleResponse = (res) => {
    try {
        if (res.status === 401) {
            window.location.href = `/`;
        }
        else if (res.status === 500) {
            return res.json();
        }
        else {
            return res !== null ? res.json() : [];
        }
    }
    catch (ex) {
        console.log(ex);
        return [];
    }
};
export function TokenExpiryWrapper(apiCall) {
    //does nothing but could refresh the api token
    //const localToken = window.localStorage.getItem('AccessToken')
    return apiCall;
}
const service = {
    get: async (url, options) => {
        const authheader = await getAuthHeader(AUDIENCE_Access);
        const payload = { ...options, ...authheader /*credentials: 'include'*/ };
        return fetch(getAPI() + url, payload).then(handleResponse);
    },
    get_data: async (url, options) => {
        const authheader = await getAuthHeader(AUDIENCE_Access);
        const payload = { ...options, ...authheader /*credentials: 'include'*/ };
        return fetch(url, payload).then(handleResponse);
    },
    post: async (url, body, options = {}) => {
        const authheader = await getAuthHeader(AUDIENCE_Access);
        return fetch(getAPI() + url, {
            ...options,
            ...authheader,
            /*credentials: 'include',*/ method: 'POST',
            body: JSON.stringify(body),
        }).then(handleResponse);
    },
    post_text: async (url, body, headers = {}) => {
        const authheader = await getAuthHeader(AUDIENCE_Access);
        const hdrs = { ...authheader.headers, ...headers.headers };
        console.log(hdrs);
        return fetch(getAPI() + url, {
            headers: hdrs,
            method: 'POST',
            body: body, //not stringified to json
        }).then(handleResponse);
    },
    put: async (url, body, options = {}) => {
        const authheader = await getAuthHeader(AUDIENCE_Access);
        return fetch(getAPI() + url, {
            ...options,
            ...authheader,
            /*credentials: 'include',*/ method: 'PUT',
            body: JSON.stringify(body),
        }).then(handleResponse);
    },
    delete: async (url, options = {}) => {
        const authheader = await getAuthHeader(AUDIENCE_Access);
        return fetch(getAPI() + url, {
            ...options,
            ...authheader,
            /*credentials: 'include',*/ method: 'DELETE',
        }).then(handleResponse);
    },
};
export async function fetchUrl(url) {
    return service.get(url, {});
}
export async function getRemotes() {
    return service.get(`/remotes`, {});
}
export async function getApplicationConfig() {
    return service.get(`/ConfigService`, {});
}
